
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import URL from '../constants/ServerUrl'
import { useNavigate,useSearchParams } from 'react-router-dom'


const categoryOptions = [
  { value: 'KGFAT + KGSNF', label: 'KGFAT + KGSNF' },
  { value: 'KG FAT ONLY', label: 'KG FAT ONLY' },
]

const levelOptions = [
  { value: 1, label: 'Level 1' },
  { value: 2, label: 'Level 2' },
  { value: 3, label: 'Level 3' },
  { value: 4, label: 'Level 4' },
]

const EditRateChart = ({ route }) => {
  const [showDropDown1, setShowDropDown1] = useState(false)
  const [showDropDown2, setShowDropDown2] = useState(false)
  const [category, setCategory] = useState('KGFAT + KGSNF')
  const [level, setLevel] = useState(null)
  const [rateChartName, setRateChartName] = useState('')
  const [stdFatRate, setStdFatRate] = useState()
  const [stdSNFRate, setStdSNFRate] = useState()
  const [stdTSRate, setStdTSRate] = useState()
  const [incentive, setIncentive] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const id = searchParams.get('id');
  const token = localStorage.getItem("dairy-token")
  const navigator=useNavigate();



  const fetchRateData = async () => {
    try {
      if (username) {
        const res = await axios.get(`${URL}admin/${username}/ratelist/${id}`,{
          Authorization: `Bearer ${token}`,
        })

        setCategory(res.data.category)
        setLevel(res.data.level)
        setRateChartName(res.data.rateChartName)
        setStdFatRate(res.data.stdFatRate)
        setStdSNFRate(res.data.stdSNFRate)
        setStdTSRate(res.data.stdTSRate)
        setIncentive(res.data.incentive)
        console.log(res.data);
      }
    } catch (error) {
      console.log('Error:', error)
    }
  }
  useEffect(() => {
    fetchRateData()
  }, [])

  const updateRateChart = async () => {
    try {
      if (username) {
        setIsLoading(true)
        const res = await axios.put(`${URL}admin/${username}/ratelist/${id}`, {
          category,
          level,
          rateChartName,
          stdFatRate,
          stdSNFRate,
          stdTSRate,
          incentive,
        },{
          Authorization: `Bearer ${token}`,
        })

        setIsLoading(false)
        alert('Rate Chart Updated Successfully')
        fetchRateData()
      }
      navigator(-1);
    } catch (error) {
      setIsLoading(false)
      alert('Error in updating rate chart')
      console.log(error)
    }
  }

  return (
    <div className="container mx-auto p-4 bg-white shadow rounded-lg">
  
    <div className="flex flex-col space-y-4">
      <select
        className="p-2 border border-gray-300 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-200 focus:outline-none"
        value={category}
        onChange={(e) => setCategory(e.target.value)}
      >
        {categoryOptions.map((option, index) => (
          <option key={index} value={option.value}>{option.label}</option>
        ))}
      </select>
  
      <select
        className="p-2 border border-gray-300 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-200 focus:outline-none"
        value={level}
        onChange={(e) => setLevel(e.target.value)}
      >
        {levelOptions.map((option, index) => (
          <option key={index} value={option.value}>{option.label}</option>
        ))}
      </select>
  
      <input
        className="p-2 border border-gray-300 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-200 focus:outline-none"
        placeholder="Enter Rate Chart Name"
        value={rateChartName}
        onChange={(name) => setRateChartName(name.target.value)}
      />
  
      {(category === 'KGFAT + KGSNF' || category === 'KG FAT ONLY') && (
        <input
          className="p-2 border border-gray-300 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-200 focus:outline-none"
          placeholder="Enter Standard Fat Rate"
          value={stdFatRate && stdFatRate.toString()}
          onChange={(fat) => setStdFatRate(fat.target.value)}
          type="number"
        />
      )}
  
      {category === 'KGFAT + KGSNF' && (
        <div className="space-y-4">
          <input
            className="p-2 border border-gray-300 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-200 focus:outline-none"
            placeholder="Enter Standard SNF Rate"
            value={stdSNFRate && stdSNFRate.toString()}
            onChange={(snf) => setStdSNFRate(snf.target.value)}
            type="number"
          />
          <input
            className="p-2 border border-gray-300 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-200 focus:outline-none"
            placeholder="Enter TS Rate"
            value={stdTSRate && stdTSRate.toString()}
            onChange={(rate) => setStdTSRate(rate.target.value)}
            type="number"
          />
        </div>
      )}
  
      <input
        className="p-2 border border-gray-300 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-200 focus:outline-none"
        placeholder="Enter Incentive"
        value={incentive && incentive.toString()}
        onChange={(i) => setIncentive(i.target.value)}
        type="number"
      />

      <button 
              className={`w-full bg-blue-500 text-white font-semibold py-2 px-4 rounded-md ${
                isLoading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
      onClick={()=>{
        updateRateChart()
      }}>
    {isLoading ? 'Updating...' : 'Update'}
      </button>
  
     
    </div>
  </div>
  
  )
}


export default EditRateChart